<!-- Header con gradiente -->
<div style="background: linear-gradient(135deg, #1C593D, #059669); padding: 20px 24px; display: flex; align-items: center; justify-content: space-between;">
  <div style="display: flex; align-items: center; gap: 12px;">
    <div style="display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: rgba(255,255,255,0.2); border-radius: 10px;">
      <mat-icon style="color: white; font-size: 22px; width: 22px; height: 22px; flex-shrink: 0;">token</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; color: white; font-size: 1.15rem; font-weight: 700;">Detalle del Beneficiario</h2>
      <p style="margin: 2px 0 0; color: rgba(255,255,255,0.8); font-size: 0.78rem;">Información del beneficiario cripto</p>
    </div>
  </div>
  <button type="button" (click)="onNoClick()"
    style="display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; background: rgba(255,255,255,0.2); border: none; border-radius: 8px; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='rgba(255,255,255,0.3)'" onmouseout="this.style.background='rgba(255,255,255,0.2)'">
    <mat-icon style="color: white; font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;">close</mat-icon>
  </button>
</div>

<!-- Contenido -->
<div style="padding: 24px;">
  <div style="display: flex; flex-direction: column; gap: 16px;">

    <!-- Nombre -->
    <div style="display: flex; align-items: flex-start; gap: 12px; padding: 14px 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #f3f4f6;">
      <div style="display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; background: #eff6ff; border-radius: 8px; flex-shrink: 0;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #2563eb; flex-shrink: 0;">person</mat-icon>
      </div>
      <div>
        <span style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nombre</span>
        <p style="margin: 2px 0 0; font-size: 0.92rem; font-weight: 700; color: #111827;">{{ data.beneficiario_nombre }} {{ data.beneficiario_apellido }}</p>
      </div>
    </div>

    <!-- Red -->
    <div style="display: flex; align-items: flex-start; gap: 12px; padding: 14px 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #f3f4f6;">
      <div style="display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; background: #fef3c7; border-radius: 8px; flex-shrink: 0;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #f59e0b; flex-shrink: 0;">token</mat-icon>
      </div>
      <div>
        <span style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Red</span>
        <p style="margin: 2px 0 0; font-size: 0.92rem; font-weight: 700; color: #111827;">{{ data.medioCriptomoneda_descripcion }}</p>
      </div>
    </div>

    <!-- Wallet -->
    <div style="display: flex; align-items: flex-start; gap: 12px; padding: 14px 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #f3f4f6;">
      <div style="display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; background: #f0fdf4; border-radius: 8px; flex-shrink: 0;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D; flex-shrink: 0;">account_balance_wallet</mat-icon>
      </div>
      <div style="min-width: 0;">
        <span style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Wallet</span>
        <p style="margin: 2px 0 0; font-size: 0.85rem; font-weight: 600; color: #2563eb; font-family: monospace; word-break: break-all;">{{ data.beneficiario_medio_recepcion }}</p>
      </div>
    </div>

  </div>
</div>

<!-- Footer -->
<div style="padding: 16px 24px; border-top: 1px solid #f3f4f6; display: flex; justify-content: flex-end;">
  <button type="button" (click)="onNoClick()"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    Cerrar
  </button>
</div>
